import React, { Component } from 'react'
import Modal from 'react-modal'
import CacheKeys from '../../cache/CacheKeys'
import CacheManager from '../../cache/CacheManager'
import CustomerListPageUI from './CustomerListPageUI.js'
import RestApiUtils from '../../apiclient/moebli/RestApiUtils';

class CustomerListPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      messageList: null,
      customerList: null,
      filteredCustomerList: null,
      // filters
      searchFilter: '',
      //
      successMsg: null,
      errorList: null,
      createMode: false,
      updateMode: false,
      deleteMode: false,
      submitted: false,
      selectedCount: 0,
      //selected customer id for update
      selectedCustomer: null
    }
  }

  render() {
    return (
      <CustomerListPageUI
        context={this.props.context}
        messageList={this.state.messageList}
        customerList={this.state.customerList}
        filteredCustomerList={this.state.filteredCustomerList}
        // filters
        searchFilter={this.state.searchFilter}
        onSearchFilterChange={this.onSearchFilterChange}
        // form
        successMsg={this.state.successMsg}
        errorList={this.state.errorList}
        setErrorList={(errorList) => { this.setState({ errorList: errorList }) }}
        // modes
        selectedCount={this.state.selectedCount}
        createMode={this.state.createMode}
        updateMode={this.state.updateMode}
        deleteMode={this.state.deleteMode}
        submitted={this.state.submitted}
        // events
        onRowClick={this.onRowClick}
        onRefreshClick={this.onRefreshClick}
        onCreateClick={(event) => { this.setState({createMode: true}) }}
        onUpdateClick={(event) => { this.setState({updateMode: true}) }}
        onDeleteClick={(event) => { this.setState({deleteMode: true}) }}
        onConfirmUpdateClick={this.onConfirmUpdateClick}
        onCancelClick={this.onCancelClick}
        // create customer modal
        onCreateCustomerClick={(event) => { this.setState({createMode: true}) }}
        createCustomerMode={this.state.createMode}
        onCancelCreateCustomer={(event) => { this.setState({createMode: false}) }}
        onCreateCustomerComplete={this.onCreateCustomerComplete}
        // update customer modal
        onUpdateCustomerClick={(event) => { this.setState({updateMode: true}) }}
        updateCustomerMode={this.state.updateMode}
        onCancelUpdateCustomer={(event) => { this.setState({updateMode: false}) }}
        onUpdateCustomerComplete={this.onUpdateCustomerComplete}
        // delete customer modal
        onDeleteCustomerClick={(event) => { this.setState({deleteMode: true}) }}
        deleteCustomerMode={this.state.deleteMode}
        onCancelDeleteCustomer={(event) => { this.setState({deleteMode: false}) }}
        onDeleteCustomerComplete={this.onDeleteCustomerComplete}
        selectedCustomer={this.state.selectedCustomer}
      />

    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getCustomers(context)
    this.getMessages(context)
    // https://stackoverflow.com/questions/48269381/warning-react-modal-app-element-is-not-defined-please-use-modal-setappeleme
    Modal.setAppElement('body')
  }

  getCustomers(context) {
    let cacheManager = new CacheManager({
      resource: `/api/accounts/${context.session.accountId}/customers`,
      cacheKey: CacheKeys.Customers(context.session.accountId),
      callback: this.getCustomersCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getCustomersCallback = (response) => {
    response.customerList && response.customerList.forEach(customer => {
      customer.selected = false
    })

    let filtersStr = sessionStorage.getItem(CacheKeys.CustomersFilter(this.props.context.session.accountId))
    let filters = filtersStr ? JSON.parse(filtersStr) : {}

    this.applyFilters(response.customerList, filters.searchFilter ? filters.searchFilter : '', response.errorList)
    // this.setState({errorList: response.errorList, customerList : response.customerList})
  }

  applyFilters(customerList, searchFilter, errorList) {
    let filteredList = customerList
    if (searchFilter)
      filteredList = filteredList.filter(customer => customer.customerName.toLocaleLowerCase().includes(searchFilter.toLocaleLowerCase()))

    // remove checked flag from rows that are hidden
    let selectedSet = new Set()
    customerList.filter(customer => customer.selected).forEach(customer => { selectedSet.add(customer.customerId) })
    customerList.forEach(customer => { customer.selected = false })
    filteredList.filter(customer => selectedSet.has(customer.customerId)).forEach(customer => { customer.selected = true })

    this.setState({
      customerList: customerList,
      filteredCustomerList: filteredList,
      searchFilter: searchFilter,
      selectedCount: filteredList.filter(customer => customer.selected).length,
      errorList: errorList
    })

    let filters = { searchFilter: searchFilter }
    sessionStorage.setItem(CacheKeys.CustomersFilter(this.props.context.session.accountId), JSON.stringify(filters))
  }

  onRefreshClick = () => {
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.Customers(context.session.accountId))
    CacheManager.removeObject(CacheKeys.Messages('pg_acc_cust', context.locale))
    this.setState({
      customerList: null,
      filteredCustomerList: null
    }, this.getCustomers(context))
  }

  onSearchFilterChange = (event) => {
    let searchFilter = event.target.value
    this.setState({ searchFilter: searchFilter })
    this.applyFilters(this.state.customerList, searchFilter)
  }

  onRowClick = event => {
    let customerId = event.currentTarget.getAttribute('data-row-id')
    let customerList = this.state.customerList
    customerList
      .filter(customer => customer.customerId != customerId)
      .forEach(customer => {
        customer.selected = false
      })
    customerList
      .filter(customer => customer.customerId == customerId)
      .forEach(customer => {
        customer.selected = !Boolean(customer.selected)
      })
    let customer = customerList.find(customer => customer.selected)

    this.setState({ selectedCustomer: customer, customerList: customerList })
    this.applyFilters(customerList, this.state.searchFilter)
  }

  onCreateCustomerComplete = (customer) => {
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.Customers(context.session.accountId))

    let customerList = this.state.customerList
    customerList.unshift(customer)
    this.applyFilters(customerList, this.state.searchFilter)

    setTimeout(() => {
      this.setState({ createMode: false })
    }, 2000)
  }

  onUpdateCustomerComplete = (customer) => {
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.Customers(context.session.accountId))
    // this.getCustomers(context);

    let customerList = this.state.customerList.slice()
    var index = customerList.findIndex(item => item.customerId === customer.customerId)
    customerList[index] = customer
    this.applyFilters(customerList, this.state.searchFilter)

    setTimeout(() => {
      this.setState({ updateMode: false })
    }, 2000)
  }

  onDeleteCustomerComplete = (customer) => {
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.Customers(context.session.accountId))
    // this.getCustomers(context);

    let customerList = this.state.customerList.slice()
    var index = customerList.findIndex(item => item.customerId === customer.customerId)
    customerList.splice(index, 1)
    this.applyFilters(customerList, this.state.searchFilter)

    setTimeout(() => {
      this.setState({ deleteMode: false })
    }, 2000)
  }

  onCancelClick = () => {
    this.setState({
      createMode: false,
      updateMode: false,
      deleteMode: false
    });
  }

  setStateValue = (fieldName, value) => {
    this.setState({
      [fieldName]: value
    });
  }

  getMessages(context) {
    let arr = [
      'c_customers',
      'c_customer_name',
      'c_add',
      'c_update',
      'c_refresh',
      'c_cancel',
      'c_name',
      'c_first_name',
      'c_last_name',
      'c_contact_name',
      'c_phone_number',
      'c_email',
      'c_create_customer',
      'c_update_customer',
      'c_delete_customer'
    ]
    let keys = arr.join(',')

    let cacheManager = new CacheManager({
      resource: `/api/pub/messages/${keys}/locale/${context.locale}`,
      cacheKey: CacheKeys.Messages('pg_acc_cust2', context.locale),
      callback: this.getMessagesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getMessagesCallback = (response) => {
    this.setState({ messageList: response.messageList })
  }
}

export default CustomerListPageSF
